import React from "react";

import Select from "react-select";

import PropTypes from "prop-types";

import { translate } from "../i18n";

/**
 * Componente que renderiza un select con los códigos de país.
 *
 * @param props - Propiedades del componente.
 *
 * @returns Elemento JSX que renderiza el componente.
 */
function CountrySelect(props) {

  const { formik, loading, countries } = props;

  const options = countries.map((option) => ({
    label: (
      <div className="d-flex p-0 align-items-center">

        <option.flag width="24" height="24" style={{ marginRight: "8px" }} />

        <span className="d-block d-md-none">{` (+${option.idd})`}</span>
        <span className="d-none d-md-block">{`${option.a2} (+${option.idd})`}</span>

      </div>
    ),
    value: `${option.a2} ${option.idd}`,
    idd: option.idd,
  }));

  return (

    <Select
      className="border-light rounded"
      aria-label={translate("country-code")}
      placeholder={translate("country")}
      id="countryCode"
      name="countryCode"
      value={options.find((option) => option.value === formik.values.countryCode)}
      onChange={(selectedOption) => formik.setFieldValue("countryCode", selectedOption.value)}
      onBlur={formik.handleBlur}
      isDisabled={loading}
      isRequired
      options={options}
      noOptionsMessage={() => translate("valid-country-code")}
      styles={{
        control: (base, state) => ({
          ...base,
          fontSize: "0.875rem",
          paddingTop: "0.3rem",
          paddingBottom: "0.3rem",
          paddingLeft: "0.3rem",
          borderColor: "transparent",
          backgroundColor: "#f6f6f6",
          boxShadow: state.isFocused ? "#00636A" : "none",
        }),
        input: (base) => ({
          ...base,
          margin: 0,
          padding: 0,
          height: "auto",
        }),
        dropdownIndicator: (base) => ({
          ...base,
          color: "#00636A",
        }),
        indicatorSeparator: (base) => ({
          ...base,
          display: "none",
        }),
      }}
    />

  );

}

CountrySelect.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.shape({
      countryCode: PropTypes.string.isRequired,
    }).isRequired,
    setFieldValue: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      a2: PropTypes.string.isRequired,
      idd: PropTypes.number.isRequired,
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};

export default CountrySelect;
